/**
 * OAuth2 Client 설정 상수
 * Spring Authorization Server에 등록된 클라이언트 정보
 */ /**
 * 기본 OAuth2 클라이언트 설정
 */ export var OAUTH_CLIENTS = {
    /**
   * 메인 애플리케이션 클라이언트
   */ APP_CLIENT: {
        clientId: 'app-client',
        clientSecret: undefined,
        redirectUri: 'https://app.ugot.uk/oauth2/redirect',
        scopes: [
            'openid',
            'profile',
            'email',
            'api.read',
            'offline_access'
        ],
        grantTypes: [
            'authorization_code',
            'refresh_token'
        ],
        authMethod: 'none' // public client
    },
    /**
   * 관리자 클라이언트 (confidential client)
   */ ADMIN_CLIENT: {
        clientId: 'admin-client',
        clientSecret: 'adminSecret2024!',
        redirectUri: 'https://admin.ugot.uk/callback',
        scopes: [
            'admin',
            'api.read',
            'api.write'
        ],
        grantTypes: [
            'client_credentials'
        ],
        authMethod: 'client_secret_basic',
        requireProofKey: false,
        requireAuthorizationConsent: false,
        tokenSettings: {
            accessTokenTTL: 'PT1H',
            refreshTokenTTL: 'P30D',
            reuseRefreshTokens: false,
            accessTokenFormat: 'REFERENCE'
        }
    },
    /**
   * 모바일 앱 클라이언트
   */ MOBILE_CLIENT: {
        clientId: 'mobile-client',
        clientSecret: undefined,
        redirectUri: 'com.ugot.app://oauth2/redirect',
        scopes: [
            'openid',
            'profile',
            'email',
            'api.read',
            'offline_access'
        ],
        grantTypes: [
            'authorization_code',
            'refresh_token'
        ],
        authMethod: 'none',
        requireProofKey: true
    },
    /**
   * CLI 도구 클라이언트
   */ CLI_CLIENT: {
        clientId: 'cli-client',
        clientSecret: undefined,
        redirectUri: 'http://localhost:8080/callback',
        scopes: [
            'openid',
            'profile',
            'api.read',
            'api.write',
            'offline_access'
        ],
        grantTypes: [
            'authorization_code',
            'refresh_token'
        ],
        authMethod: 'none',
        requireProofKey: true
    },
    /**
   * 서비스 간 통신용 클라이언트
   */ SERVICE_CLIENT: {
        clientId: 'service-client',
        clientSecret: '{bcrypt}$2a$10$GRLdNijSQMUvl/au9ofL.eDwmoohzzS7.rmNSJZ.0FxO/BTk76klW',
        scopes: [
            'api.read',
            'api.write',
            'api.admin'
        ],
        grantTypes: [
            'client_credentials'
        ],
        authMethod: 'client_secret_basic'
    },
    /**
   * 테스트용 클라이언트
   */ TEST_CLIENT: {
        clientId: 'test-client',
        clientSecret: '{noop}test-secret',
        redirectUri: 'http://localhost:3000/callback',
        scopes: [
            'openid',
            'profile',
            'email',
            'api.read',
            'offline_access'
        ],
        grantTypes: [
            'authorization_code',
            'refresh_token',
            'client_credentials'
        ],
        authMethod: 'client_secret_post'
    }
};
/**
 * OAuth2 엔드포인트 URL
 */ export var OAUTH_ENDPOINTS = {
    authorize: 'https://auth.ugot.uk/oauth2/authorize',
    token: 'https://auth.ugot.uk/oauth2/token',
    revoke: 'https://auth.ugot.uk/oauth2/revoke',
    introspect: 'https://auth.ugot.uk/oauth2/introspect',
    jwks: 'https://auth.ugot.uk/oauth2/jwks',
    userinfo: 'https://auth.ugot.uk/oauth2/userinfo',
    // Proxy endpoints for frontend
    proxyToken: 'https://auth.ugot.uk/api/proxy/token',
    proxyRevoke: 'https://auth.ugot.uk/api/proxy/revoke'
};
/**
 * OAuth2 응답 타입
 */ export var OAUTH_RESPONSE_TYPES = {
    CODE: 'code',
    TOKEN: 'token',
    ID_TOKEN: 'id_token'
};
/**
 * OAuth2 Grant Types
 */ export var OAUTH_GRANT_TYPES = {
    AUTHORIZATION_CODE: 'authorization_code',
    REFRESH_TOKEN: 'refresh_token',
    CLIENT_CREDENTIALS: 'client_credentials',
    PASSWORD: 'password',
    IMPLICIT: 'implicit' // deprecated, not recommended
};
/**
 * PKCE 설정
 */ export var PKCE_CONFIG = {
    CODE_VERIFIER_LENGTH: 128,
    CODE_CHALLENGE_METHOD: 'S256'
};
/**
 * 토큰 만료 시간 (초)
 */ export var TOKEN_EXPIRY = {
    ACCESS_TOKEN: 3600,
    REFRESH_TOKEN: 2592000,
    ID_TOKEN: 3600 // 1시간
};
/**
 * 기본 클라이언트 ID (앱에서 사용)
 */ export var DEFAULT_CLIENT_ID = OAUTH_CLIENTS.APP_CLIENT.clientId;
/**
 * 기본 리다이렉트 URI
 */ export var DEFAULT_REDIRECT_URI = OAUTH_CLIENTS.APP_CLIENT.redirectUri;
